import { withInlineSVG } from 'components/patterns/icons/svg-tools/generator/withInlineSVG'

import About from './AboutYourself.svg'
import Work from './GetToWork.svg'
import Score from './GetYourScore.svg'

const AboutYourself = withInlineSVG(About)

const GetToWork = withInlineSVG(Work)

const GetYourScore = withInlineSVG(Score)

export const ApprovabilityIcons = { AboutYourself, GetToWork, GetYourScore }
